function Profile() {
    return (
      
      <section className="CompleteProfile">
        <h1>hi profile</h1>
      </section>
    );
  }
  
  export default Profile;